<template>
  <v-sheet class="px-8 pt-10 pb-4">
    <v-row dense>
      <v-col @click="$emit('view', 'referral')" class="text-center cursor-pointer" cols="6">
        <v-card outlined class="py-6">
          <v-icon color="blue">mdi-account-group</v-icon>
          <div class="text-small mt-1">Resellers</div>
        </v-card>
      </v-col>
      <v-col @click="$emit('view', 'whatsapp')" class="text-center cursor-pointer" cols="6">
        <v-card outlined class="py-6">
          <v-icon color="green">mdi-whatsapp</v-icon>
          <div class="text-small mt-1">Chat with merchant</div>
        </v-card>
      </v-col>
      <v-col @click="$emit('view', 'about')" class="text-center cursor-pointer" cols="6">
        <v-card outlined class="py-6">
          <v-icon color="teal">mdi-account-box</v-icon>
          <div class="text-small mt-1">About us</div>
        </v-card>
      </v-col>
      <v-col
        v-if="$store.state.request.id"
        @click="$router.push(`/request/${$store.state.request.slug}/all`)"
        class="text-center cursor-pointer" cols="6"
      >
        <v-card outlined class="py-6">
          <v-icon color="orange">mdi-clipboard-list</v-icon>
          <div class="text-small mt-1">Active requests</div>
        </v-card>
      </v-col>
    </v-row>
    <v-list color="transparent" class="mt-4">
      <v-list-item-group color="primary">
        <v-list-item class="px-6">
          <v-list-item-icon class="mr-5">
            <v-icon>mdi-alert-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Buy airtime pay later</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="px-6">
          <v-list-item-icon class="mr-5">
            <v-icon>mdi-alert-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Subscribe DSTV pay later</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-sheet>
</template>

<script>
export default {
  name: "MoreLinks"
}
</script>
